export default __webpack_public_path__ + "static/media/gloss_t.6c689d59.svg";